"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "dirty": false,
    "raw": "v1.22.0-0-g39a4e73",
    "hash": "g39a4e73",
    "distance": 0,
    "tag": "v1.22.0",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.22.0",
        "major": 1,
        "minor": 22,
        "patch": 0,
        "prerelease": [],
        "build": [],
        "version": "1.22.0"
    },
    "suffix": "0-g39a4e73",
    "semverString": "1.22.0"
};
//# sourceMappingURL=version.js.map